import React, { Component } from "react";
import $ from "jquery";
import ListLocationsModal from "./ListLocationsModal";

class LocationAssignment extends Component {

    closeDocuments = async () => {
        const { CleanData } = this.props;
        $("#locationAssignment").modal("hide");
        await CleanData();

        setTimeout(() => {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        }, 300);
    };

    changeBatFromWarehouse = async (value = "", index = -1, LineNum = 0) => {
        const { showAlert, updateModel, view = '' } = this.props;
        const newValue = value.trim();
        if (!(/^\d*(\.\d{0,6})?$/.test(newValue)) && newValue != '') {
            return
        }
        let newOrderModel = JSON.parse(JSON.stringify(this.props.newOrderModel));
        const isSalesDocument = newOrderModel.isSalesDocument;
        const newView = newOrderModel.newView || view;
        const DocBinView = isSalesDocument || newView === 'transfersOutput';
        let item = newOrderModel.Items.find(i => i.LineNum === LineNum);
        let location = !DocBinView ? item.FromLocationAssignment[index] : item.DocumentLinesBinAllocations[index];
        if (newValue.indexOf(" ") !== -1 || newValue.indexOf("-") !== -1) {
            showAlert({ type: 'warning', message: "Carácter no permitido" });
            return;
        }
        location.Quantity = newValue;
        await updateModel(newOrderModel);
    }

    validateItemLocations = (
        item,
        locations,
        changedIndex,
        showAlert
    ) => {
        let totalAssigned = 0;

        for (let i = 0; i < locations.length; i++) {
            const location = locations[i];

            const quantity = Number(location.Quantity ?? 0);
            const onHandQty = Number(location.OnHandQty ?? 0);

            if (!Number.isFinite(quantity) || quantity < 0) {
                location.Quantity = "0";
                location.remainingQty = onHandQty.toFixed(6);

                item.TotalAsigned = locations
                    .reduce(
                        (total, current) =>
                            total + Number(current.Quantity ?? 0),
                        0
                    )
                    .toFixed(6);

                showAlert({
                    type: "warning",
                    message: "Ingrese un número válido"
                });

                return false;
            }

            if (quantity > onHandQty) {
                location.Quantity = "0";
                location.remainingQty = onHandQty.toFixed(6);

                item.TotalAsigned = locations
                    .reduce(
                        (total, current) =>
                            total + Number(current.Quantity ?? 0),
                        0
                    )
                    .toFixed(6);

                showAlert({
                    type: "warning",
                    message:
                        "La cantidad asignada no puede ser mayor al stock disponible"
                });

                return false;
            }

            location.remainingQty = (
                onHandQty - quantity
            ).toFixed(6);

            totalAssigned += quantity;
        }

        const requestedQuantity = Number(item.Quantity ?? 0);

        if (totalAssigned > requestedQuantity) {
            locations[changedIndex].Quantity = "0";

            const changedLocation = locations[changedIndex];

            changedLocation.remainingQty = Number(
                changedLocation.OnHandQty ?? 0
            ).toFixed(6);

            totalAssigned = locations.reduce(
                (total, current) =>
                    total + Number(current.Quantity ?? 0),
                0
            );

            item.TotalAsigned = totalAssigned.toFixed(6);

            showAlert({
                type: "warning",
                message:
                    "La cantidad asignada no puede ser mayor a la cantidad requerida"
            });

            return false;
        }

        item.TotalAsigned = totalAssigned.toFixed(6);

        return true;
    };

    validateBatFromWarehouse = async (
        value = "",
        index = -1,
        LineNum = 0
    ) => {
        const {
            newOrderModel,
            updateModel,
            view = "",
            showAlert
        } = this.props;

        const isSalesDocument = newOrderModel.isSalesDocument;
        const newView = newOrderModel.newView || view;
        const DocBinView =
            isSalesDocument || newView === "transfersOutput";

        const item = newOrderModel.Items.find(
            i => i.LineNum === LineNum
        );

        if (!item) {
            return;
        }

        const locations = !DocBinView
            ? item.FromLocationAssignment
            : item.DocumentLinesBinAllocations;

        const location = locations?.[index];

        if (!location) {
            return;
        }

        const inputValue = String(value ?? "").trim();
        const numberRegex = /^\d+(\.\d{0,6})?$/;

        if (
            inputValue === "" ||
            inputValue === "." ||
            !numberRegex.test(inputValue)
        ) {
            location.Quantity = "0";
            location.remainingQty = Number(
                location.OnHandQty ?? 0
            ).toFixed(6);

            await this.validateItemLocations(
                item,
                locations,
                index,
                showAlert
            );

            return;
        }

        const quantity = Number(inputValue);

        if (!Number.isFinite(quantity)) {
            location.Quantity = "0";

            await this.validateItemLocations(
                item,
                locations,
                index,
                showAlert
            );

            return;
        }

        location.Quantity = quantity.toFixed(6);

        const isValid = this.validateItemLocations(
            item,
            locations,
            index,
            showAlert
        );

        if (!isValid) {
            await updateModel(newOrderModel);
            return;
        }

        await updateModel(newOrderModel);
    };

    changeBatToWarehouse = async (value = "", index = -1, LineNum = 0) => {
        const { showAlert, updateModel, view = '' } = this.props;
        const newValue = value.trim();

        let newOrderModel = JSON.parse(JSON.stringify(this.props.newOrderModel));
        const isPurchaseDocument = newOrderModel.isPurchaseDocument;
        const newView = newOrderModel.newView || view;
        const DocBinView = isPurchaseDocument || newView === 'transfersEntry';
        let item = newOrderModel.Items.find(i => i.LineNum === LineNum);

        let firstWithQuantity;
        let location;
        if (!DocBinView) { // Original
            firstWithQuantity = item.ToLocationAssignment.find(
                loc => Number(loc.Quantity) !== 0
            );
            location = item.ToLocationAssignment[index];
        } else { // Nuevo para compras - Entrada de mercancía
            firstWithQuantity = item.DocumentLinesBinAllocations.find(
                loc => Number(loc.Quantity) !== 0
            );
            location = item.DocumentLinesBinAllocations[index];
        }

        if (!isNaN(newValue)) {
            let totalAssigned = Number(item.ToTotalAsigned ?? 0);
            let locationQty = Number((location?.Quantity === "." ? 0 : location?.Quantity) ?? 0);
            let quantity = Number(newValue ?? 0);

            totalAssigned = totalAssigned - locationQty;
            item.ToTotalAsigned = totalAssigned.toFixed(6);

            totalAssigned = totalAssigned + quantity;
            item.ToTotalAsigned = totalAssigned.toFixed(6);
            item.FirstBin = firstWithQuantity?.BinCode || '';

            location.Quantity = newValue;
            location.remainingQty = (Number(location?.OnHandQty) - quantity).toFixed(6);

            if (Number(item.ToTotalAsigned) > Number(item.Quantity)) { return showAlert({ type: 'warning', message: "La cantidad asignada no puede ser mayor a la cantidad requerida" }); }
        }
        else if (newValue === ".") { location.Quantity = newValue; }
        else { return showAlert({ type: 'warning', message: "Ingrese un número valido" }); }
        await updateModel(newOrderModel);
    }

    validateBatToWarehouse = async (value = "", index = -1, LineNum = 0) => {
        const { newOrderModel, updateModel, view = '' } = this.props;
        const isPurchaseDocument = newOrderModel.isPurchaseDocument;
        const newView = newOrderModel.newView || view;
        const DocBinView = isPurchaseDocument || newView === 'transfersEntry';

        let item = newOrderModel.Items.find(i => i.LineNum === LineNum);
        let location = !DocBinView ? item.ToLocationAssignment[index] : item.DocumentLinesBinAllocations[index];
        let firstWithQuantity;
        if (!DocBinView) { // Original
            firstWithQuantity = item.ToLocationAssignment.find(
                loc => Number(loc.Quantity) !== 0
            );
        } else { // Nuevo para compras - Entrada de mercancía
            firstWithQuantity = item.DocumentLinesBinAllocations.find(
                loc => Number(loc.Quantity) !== 0
            );
        }
        let quantity = Number(isNaN(value) ? 0 : value)
        location.Quantity = quantity.toFixed(6);
        item.FirstBin = firstWithQuantity?.BinCode || '';
        await updateModel(newOrderModel);
    }

    deleteLocation = async (index = -1) => {
        const { newOrderModel, updateModel, lineNumLocation } = this.props;

        if (index < 0) return;

        const item = newOrderModel.Items.find(i => i.LineNum === lineNumLocation);
        if (!item || !Array.isArray(item.DocumentLinesBinAllocations)) return;

        item.DocumentLinesBinAllocations.splice(index, 1);

        item.ToTotalAsigned = item.DocumentLinesBinAllocations.reduce(
            (acc, loc) => acc + Number(loc.Quantity || 0),
            0
        );

        const firstWithQuantity = item.DocumentLinesBinAllocations.find(
            loc => Number(loc.Quantity) !== 0
        );
        item.FirstBin = firstWithQuantity?.BinCode || '';

        await updateModel(newOrderModel);
    };


    render() {
        const {
            newOrderModel
            , option
            , lineNumLocation
            , openLocations
            , changeSearchLocations
            , locations
            , pageTotal
            , cleanData
            , showListLocationsModal
            , refreshLocations
            , selectLocation
            , view = ''
        } = this.props;
        let { action = 0 } = this.props;

        const data = newOrderModel.Items.filter(({ LineNum }) => LineNum === lineNumLocation);
        const isPurchaseDocument = newOrderModel.isPurchaseDocument;
        const isSalesDocument = newOrderModel.isSalesDocument;
        const isMarketingDoc = isPurchaseDocument || isSalesDocument;
        const newView = newOrderModel.newView || view;
        const DocBinView = isMarketingDoc || newView === 'transfersEntry' || newView === 'transfersOutput';
        action = Number(action || 0);

        return (
            <>
                <div className="modal fade" id="locationAssignment" data-keyboard="false" tabIndex="-1" aria-labelledby="savedSalesModalLabel" aria-hidden="true" >
                    <div className="modal-dialog modal-lg modal-open" >
                        <div className="modal-content">
                            <div className="modal-header text-white"
                                style={{ backgroundColor: "#343a40", borderRadius: "0" }}>

                                <h4 className="modal-title" id="modal-basic-title ">
                                    Asignación de ubicación - {option === 1 ? "Emisión" : "Recibo"}
                                </h4>

                                <button type="button" className="close" onClick={this.closeDocuments} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">
                                        &times;
                                    </span>
                                </button>
                            </div>
                            <div className="modal-body">
                                {/* HEADER */}
                                <div className="row">
                                    {/*Priemra columna*/}
                                    <div className="col-8">
                                        {/* Número de documento */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Número de documento</span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control input-sm"
                                                id="txtName"
                                                disabled="true"
                                                value={newOrderModel.NextFolio ? newOrderModel.NextFolio : ""} />
                                        </div>
                                        {/* Número de línea */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Número de línea</span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control input-sm"
                                                id="txtName"
                                                disabled="true"
                                                value={data[0].LineNum + 1 ? data[0].LineNum + 1 : "1"} />
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">de</span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control input-sm"
                                                id="txtName"
                                                disabled="true"
                                                value={newOrderModel.Items.length} />
                                        </div>
                                        {/* Código de almacén */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Código de almacén</span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control input-sm"
                                                id="txtName"
                                                disabled="true"
                                                value={DocBinView ? data[0]?.WhsCode || '' : (option === 1 ? (newOrderModel.Filler || newOrderModel.WhsCode) : newOrderModel.ToWhsCode) || ""} />
                                        </div>
                                        {/* Número de artículo */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Número de artículo</span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control input-sm"
                                                id="txtName"
                                                disabled="true"
                                                value={data[0].ItemCode ? data[0].ItemCode : ""} />
                                        </div>
                                        <div className="input-group mb-3">
                                        </div>
                                        {/* Cantidad */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Cantidad</span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control input-sm"
                                                id="txtName"
                                                disabled="true"
                                                value={data[0].Quantity ? data[0].Quantity : ""} />
                                        </div>
                                        {/* Total asignado */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Total asignado</span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control input-sm"
                                                id="txtName"
                                                disabled="true"
                                                value={option === 1 ? (data[0].TotalAsigned ? data[0].TotalAsigned || 0 : "") : (data[0].ToTotalAsigned ? data[0].ToTotalAsigned || 0 : "")} />
                                        </div>
                                        {/* Restante */}
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Restante</span>
                                            </div>
                                            <input
                                                type="text"
                                                className="form-control input-sm"
                                                id="txtName"
                                                disabled="true"
                                                value={(() => {
                                                    const item = data?.[0];

                                                    if (!item || item.Quantity === null || item.Quantity === undefined || item.Quantity === "") {
                                                        return "";
                                                    }

                                                    const quantity = Number(item.Quantity);
                                                    const totalAssigned = Number(
                                                        option === 1
                                                            ? item.TotalAsigned ?? 0
                                                            : item.ToTotalAsigned ?? 0
                                                    );

                                                    if (!Number.isFinite(quantity) || !Number.isFinite(totalAssigned)) {
                                                        return "";
                                                    }

                                                    return (quantity - totalAssigned)
                                                        .toFixed(6)
                                                        .replace(/\.?0+$/, "");
                                                })()}

                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* BODY */}
                                <div className="table-responsive" style={{ height: 400, maxHeight: 400, overflow: "auto", fontSize: "13px" }}>
                                    <table className="table-striped table table-hover scrolltable" style={{ width: "100%" }}>
                                        <thead className="table-header sticky-header table-header-yellow">
                                            <tr>
                                                <th className="text-center">#</th>
                                                <th className="text-left">Posición de ubicación</th>
                                                {option === 1 && <th className="text-left">En stock</th>}
                                                {option === 1 && <th className="text-left">Disponible</th>}
                                                <th className="text-left">Imputado</th>
                                                {DocBinView &&
                                                    <th className="text-center"></th>
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {option === 1 && !DocBinView && !!data[0].FromLocationAssignment && data[0].FromLocationAssignment.map((bin, index) => {
                                                return (<tr key={index}>
                                                    <td> {index + 1} </td>
                                                    <td> {bin.BinCode || ""} </td>
                                                    {option === 1 && <>
                                                        <td> {bin.OnHandQty || "0.000"} </td>
                                                        <td> {bin.remainingQty || "0.000"} </td>
                                                    </>}
                                                    <td>
                                                        <input
                                                            id="txtBinQty"
                                                            className="form-control input-sm text-right"
                                                            type="text"
                                                            value={bin.Quantity || ""}
                                                            onChange={(event) => this.changeBatFromWarehouse(event.target.value, index, data[0].LineNum)}
                                                            onBlur={() => this.validateBatFromWarehouse(bin.Quantity, index, data[0].LineNum)} />
                                                    </td>
                                                </tr>)
                                            })}
                                            {option === 1 && DocBinView && !!data[0].DocumentLinesBinAllocations && data[0].DocumentLinesBinAllocations.map((bin, index) => {
                                                return (<tr key={index}>
                                                    <td> {index + 1} </td>
                                                    <td> {bin.BinCode || ""} </td>
                                                    {option === 1 && <>
                                                        <td> {bin.OnHandQty || "0.000"} </td>
                                                        <td> {bin.remainingQty || "0.000"} </td>
                                                    </>}
                                                    <td>
                                                        <input
                                                            id="txtBinQty"
                                                            className="form-control input-sm text-right"
                                                            type="text"
                                                            value={bin.Quantity || ""}
                                                            onChange={(event) => this.changeBatFromWarehouse(event.target.value, index, data[0].LineNum)}
                                                            onBlur={() => this.validateBatFromWarehouse(bin.Quantity, index, data[0].LineNum)} />
                                                    </td>
                                                </tr>)
                                            })}
                                            {option === 2 && <>
                                                {!DocBinView && !Array.isArray(data[0]?.ToLocationAssignment) ? <></> : data[0].ToLocationAssignment.map((bin, index) =>
                                                    <tr key={index}>
                                                        <th scope="col-lg-auto row">{index + 1}</th>
                                                        <th scope="col-lg-auto row">{bin.BinCode ? bin.BinCode : ""}</th>
                                                        <td className="text-left">
                                                            <input
                                                                type="number"
                                                                className="form-control input-sm"
                                                                id="txtName"
                                                                max={`${(Number(data[0].Quantity) - Number(data[0].ToTotalAsigned || 0))}`}
                                                                value={bin.Quantity ? bin.Quantity : ""}
                                                                onChange={({ target: { value } }) => this.changeBatToWarehouse(value, index, data[0].LineNum)}
                                                                onBlur={() => this.validateBatToWarehouse(bin.Quantity, index, data[0].LineNum)} />
                                                        </td>
                                                    </tr>
                                                )}
                                                {DocBinView && !Array.isArray(data[0]?.DocumentLinesBinAllocations) ? <></> : data[0].DocumentLinesBinAllocations.map((bin, index) =>
                                                    <tr key={index}>
                                                        <th scope="col-lg-auto row">{index + 1}</th>
                                                        <th scope="col-lg-auto row">{bin.BinCode ? bin.BinCode : ""}</th>
                                                        <td className="text-left">
                                                            <input
                                                                type="number"
                                                                className="form-control input-sm"
                                                                id="txtName"
                                                                max={`${(Number(data[0].Quantity) - Number(data[0].ToTotalAsigned || 0))}`}
                                                                value={bin.Quantity ? bin.Quantity : ""}
                                                                onChange={({ target: { value } }) => this.changeBatToWarehouse(value, index, data[0].LineNum)}
                                                                onBlur={() => this.validateBatToWarehouse(bin.Quantity, index, data[0].LineNum)} />
                                                        </td>
                                                        {DocBinView &&
                                                            <td
                                                                style={{
                                                                    textAlign: 'center'
                                                                }}>
                                                                {/*Eliminar*/}
                                                                {action === 1 && (
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            padding: 5,
                                                                            color: '#c42222',
                                                                            paddingTop: 2,
                                                                            paddingBottom: 2,
                                                                        }}
                                                                        className="btn"
                                                                        onClick={() => this.deleteLocation(index)}
                                                                    >
                                                                        <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                                    </button>
                                                                )}
                                                            </td>
                                                        }
                                                    </tr>
                                                )}

                                                <tr>
                                                    <td colSpan={3} className="sticky-column" style={{ background: "white" }}>
                                                        <div className="input-group" style={{ width: 250 }}>
                                                            <input
                                                                placeholder="Posición de ubicación"
                                                                className="form-control"
                                                                onKeyDown={({ key }) => { if (key === "Enter") { openLocations(data[0].LineNum, DocBinView ? data[0]?.WhsCode || '' : null); } }}
                                                                value={newOrderModel.searchLocation || ""}
                                                                onChange={event => changeSearchLocations(event)} />

                                                            <button type="button" className="rounded-right btn btn-outline-success" onClick={() => openLocations(data[0].LineNum, DocBinView ? data[0]?.WhsCode || '' : null)}>
                                                                <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={this.closeDocuments}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {showListLocationsModal &&
                    <ListLocationsModal
                        data={locations}
                        totalPage={pageTotal}
                        newOrderModel={newOrderModel}
                        mainView={"transfers"}
                        selectLocation={selectLocation}
                        cleanData={cleanData}
                        refreshLocations={refreshLocations}
                        LineNum={data?.[0].LineNum}
                        DocBinView={DocBinView}
                        auxWhsCode={data?.[0]?.WhsCode || ''}
                    />
                }
            </>
        );
    }
}

export default LocationAssignment;